
import React from 'react';

interface PageHeroProps {
  badge: {
    icon: React.ElementType;
    text: string;
  };
  title: string;
  subtitle: string;
  description: string;
}

const PageHero = ({ badge, title, subtitle, description }: PageHeroProps) => {
  return (
    <section className="pt-32 pb-20 bg-gradient-to-br from-navy-50 to-pink-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/80 text-blue-600 px-6 py-3 rounded-full text-sm font-medium mb-8">
            <badge.icon size={16} />
            {badge.text}
          </div>
          
          <h1 className="text-6xl md:text-7xl font-light text-navy-900 mb-8 leading-tight">
            <span dangerouslySetInnerHTML={{ __html: title }} />
            <br />
            <span className="text-4xl md:text-5xl text-navy-600">{subtitle}</span>
          </h1>
          <p className="text-xl text-navy-600 mb-12 font-light leading-relaxed max-w-3xl mx-auto">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
